import { CircleArrowLeft, Home } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { TypographyMuted } from '../ui/typography';

const BottomActionBar = () => {
    const navigate = useNavigate();

    return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-sidnav-400 md:hidden shadow-lg z-20">
       <div className="grid [grid-template-columns:repeat(auto-fit,minmax(0,1fr))] items-center h-16">
         <div className="flex justify-center">
                        <button className="flex flex-col items-center text-xs text-white" onClick={() => navigate(-1)}>
                            <CircleArrowLeft size={18} />
                            <TypographyMuted className="text-white">Voltar</TypographyMuted> 
                        </button>
                    </div> 
            <div className="flex justify-center">
                <Link className="flex flex-col items-center text-xs text-white" to={'/'}> 
                    <Home size={18} />
                    <TypographyMuted className="text-white">Inicio</TypographyMuted> 
                </Link>
            </div>  
        </div>
    </div>
  );
}

export default BottomActionBar
